module.exports = __webpack_public_path__ + "img/facebook.722592ce.png";